import React, { useState } from "react";
import Chart from "react-apexcharts";

function PieChart() {
  const [options] = useState({
    legend: {
      show: false,
    },
    stroke: {
      show: false,
    },
    colors: [
      "#0EAC00",
      "#05FF00",
      "#11DA00",
      "#14F6188F",
      "#42E934",
      "#62FF01",
      "#1D960A",
      "#18AE00",
      "#3B9A00",
    ],
    dataLabels: {
      enabled: false,
    },
    // remove white border around sector
    plotOptions: {
      pie: {
        expandOnClick: false,
        dataLabels: {
          enabled: false,
        },
        colors: ["#ffffff", "#ffffff", "#ffffff"], // colors for each sector
      },
    },
  });

  const [series] = useState([20, 10.2, 28, 14, 12.8, 4, 3, 5, 3]);

  return (
    <Chart
      type="pie"
      width={460}
      options={options}
      series={series}
      height={460}
    />
  );
}

export default PieChart;